export default __webpack_public_path__ + "static/media/colorWhatIfAver.8634d200.svg";